import { useState } from 'react'
import { Star } from 'lucide-react'
import { cn } from '@/lib/utils'

interface StarRatingPickerProps {
  value: number
  onChange: (v: number) => void
}

export function StarRatingPicker({ value, onChange }: StarRatingPickerProps) {
  const [hovered, setHovered] = useState(0)
  const display = hovered > 0 ? hovered : value

  return (
    <div className="flex items-center gap-1" role="group" aria-label="Star rating">
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          key={star}
          type="button"
          aria-label={`${star} star${star !== 1 ? 's' : ''}`}
          aria-pressed={value === star}
          className="rounded-sm p-0.5 transition-transform focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 hover:scale-110"
          onMouseEnter={() => setHovered(star)}
          onMouseLeave={() => setHovered(0)}
          onClick={() => onChange(star)}
        >
          <Star
            className={cn(
              'size-7 transition-colors',
              star <= display
                ? 'fill-brand-orange stroke-brand-orange'
                : 'fill-transparent stroke-muted-foreground'
            )}
          />
        </button>
      ))}
    </div>
  )
}
